import { Divider, Modal, Row, Col, Switch } from "antd";
import React, { useRef } from "react";
import { FilterColumn, FilterText } from "./style";
import { useDispatch } from "react-redux";
import { setColumnFilter } from "../../store/slice/marketWatchSlice";
import { setTradingTradeColumn } from "../../store/slice/globleSlice";

const TableFilterModal = ({
  column,
  setShowFilter,
  checkList,
  filtertype,
  setCheckList,
}) => {
  //state
  // const [selectedColumn, setSelectedColumn] = useState(checkList);
  const columnRef = useRef(checkList);
  const dispatch = useDispatch();

  //function
  const handleCancel = () => {
    setShowFilter(false);
  };

  const handleChange = (value, name) => {
    if (value) {
      columnRef.current = [...columnRef.current, name?.value];
      // setSelectedColumn([...selectedColumn, name?.value]);
    } else {
      columnRef.current = columnRef.current?.filter((el) => el !== name?.value);
      // setSelectedColumn(selectedColumn?.filter((el) => el !== name?.value));
    }
  };

  const handleSubmit = () => {
    switch (filtertype) {
      case "marketWatch":
        dispatch(setColumnFilter(columnRef.current));
        break;
      case "trade":
        dispatch(
          setTradingTradeColumn({
            name: "tradingTradeColumn",
            value: columnRef.current,
          })
        );
        break;
      case "tradeLog":
        dispatch(
          setTradingTradeColumn({
            name: "tradeLogColumn",
            value: columnRef.current,
          })
        );
        break;
      case "brokerage":
        dispatch(
          setTradingTradeColumn({
            name: "brokerageCloumn",
            value: columnRef.current,
          })
        );
        break;
      case "csvfilesTable":
        setCheckList(columnRef.current);
        break;
      default:
        break;
    }

    setShowFilter(false);
  };

  return (
    <div>
      <Modal
        title={
          <Row gutter={[10, 10]} justify={"space-between"}>
            <Col>
              <h4>Columns Filter</h4>
            </Col>
          </Row>
        }
        open={true}
        onCancel={handleCancel}
        onOk={handleSubmit}
      >
        <Divider style={{ margin: "0px" }} />
        <Row gutter={[16, 10]} style={{ marginTop: "1rem" }}>
          {column?.map((el) => {
            return (
              <FilterColumn span={12} key={el?.title}>
                <Switch
                  defaultChecked={checkList?.includes(el?.value)}
                  onChange={(value) => handleChange(value, el)}
                  disabled={el?.disable}
                />
                <div style={{ marginTop: "0.1rem" }}>
                  <FilterText strong>{el?.title}</FilterText>
                </div>
              </FilterColumn>
            );
          })}
        </Row>
      </Modal>
    </div>
  );
};

export default React.memo(TableFilterModal);
